import { eventBus, EVENTS } from '../commons/EventBus.js';
import { Paginator } from '../commons/paginator.js';

eventBus.on( EVENTS.PAGE_AFTER_RENDERING, function(data) {
  const template=data.template;

  if(template!='home'&&template!='homepage'&&template!=''){
    return;
  }

  const breakpoints = [
    { maxWidth: 550, perPage: 2 },
    { maxWidth: 650, perPage: 2 },
    { maxWidth: 1150, perPage: 4 },
    { perPage: 6 }
  ];

  new Paginator($('#musica-paginator'), { cssVar: '--pag-classifica', breakpoints: breakpoints, total: 11, swipeElementSelector: '#homepage-simple_chart' });

  $('.home-musica-play-icon').click((e) => {

    const playingClass = 'home-musica-playing';
    const audioSrc = $(e.target).attr('data-audio');

    if(!audioSrc){
        return;
    }

    const immagine = $(e.target).attr('data-cover') || "";
    const titolo = $(e.target).attr('data-titolo') || "";
    const category = $(e.target).attr('data-category') || "";
    const giorno = $(e.target).attr('data-giorno') || "";
    const id = $(e.target).attr('data-id') || "";
    const master_id = $(e.target).attr('data-masterID') || "";
    const type = $(e.target).attr('data-type') || "";

    const song_object = {immagine: immagine,
        titolo: titolo,
        categoria: category,
        giorno: giorno,
        id: id,
        master_id: master_id,
        type: type,
        audioSrc:audioSrc
    };

    console.log(playerPodcast.getSource());
    console.log(audioSrc);

    if (playerPodcast.getSource() == audioSrc && playerPodcast.playing()) {
      playerPodcast.stop();
      $('.home-musica-play').removeClass(playingClass);
    } else if (playerPodcast.getSource() == audioSrc) {
        openPlayerBottom();
        playerPodcast.play();
    } else {
        playerPodcast.setSource(audioSrc);
        openPlayerBottom();
        eventBus.emit(EVENTS.PLAYER_PODCAST_NEW_SONG, song_object)
        playerPodcast.play();
    }

    window.fillExtendedPlayer(type, category, id, ".home-musica-play-icon");

  });

  playerPodcast.on('resume', (a, b, c) => {
    const playingClass = 'home-musica-playing';
    const playables = $('.home-musica-play .home-musica-play-icon');
    $('.home-musica-play').removeClass(playingClass);
    for (let i = 0; i < playables.length; i++) {
      const playable = playables[i];
      if ($(playable).attr('data-audio') == playerPodcast.getSource()) {
        $(playable).closest('.home-musica-play').addClass(playingClass);
      }
    }
  });

  playerPodcast.on('pause', () => {
    const playingClass = 'home-musica-playing';
    $('.home-musica-play').removeClass(playingClass);
  });

});
